import { useEffect, useState } from "react";

/**
 * Which drawing the settings modal (TV-20) is open for; ⚙ of the drawing
 * toolbar and ✏️ in the Current tab open it. Save goes to engine.updateDrawing,
 * Remove removes the drawing; both close the modal. The modal closes by itself
 * when its drawing is gone.
 *
 * @param {object} drawingsApi - useDrawings
 * @returns {{
 *   open: (id: string) => void,
 *   modal: { drawing: object, palette: string[], onSave: Function, onRemove: Function, onClose: Function } | null,
 * }} modal: props of DrawingSettingsModal, null while it is closed
 */
const useDrawingSettingsModal = ({ drawings, palette, update, remove }) => {
  const [editingId, setEditingId] = useState(null);
  const drawing = drawings.find(({ id }) => id === editingId) || null;

  useEffect(() => {
    if (editingId && !drawing) setEditingId(null);
  }, [editingId, drawing]);

  const close = () => setEditingId(null);

  return {
    open: setEditingId,
    modal: drawing && {
      drawing,
      palette,
      onClose: close,
      onSave: (settings) => {
        update(editingId, settings);
        close();
      },
      onRemove: () => {
        remove(editingId);
        close();
      },
    },
  };
};

export default useDrawingSettingsModal;
